const FIXED_CODES = ["F", "G", "K", "Z"];

export { FIXED_CODES };
